import * as React from 'react';

import { MapProvider } from '../../../common/components/map';

import { IntersectionProvider } from '../../new-providers';

import AlertProvider              from '../alert';
import BookmarksProvider          from '../bookmarks/bookmarks.provider';
import CompareProvider            from '../compare';
import CatalogProvider            from '../catalog';
import CompareModalProvider       from '../compareModal';
import CommonProvider             from '../common';
import CompletedProjectProvider   from '../completed-project';
import DealerRequestModalProvider from '../dealerRequest';
import DeleteCompareModalProvider from '../deleteCompareModal';
import FavoritesProvider          from '../favorites/favorites.provider';
import InformationProvider        from '../information';
import LightboxProvider           from '../lightbox';
import ModalProvider              from '../modal';
import NavigationProvider         from '../navigation';
import NewsProvider               from '../news';
import NotificationProvider       from '../notification';
import PromotionsProvider         from '../promotions';
import SearchProvider             from '../search';
import ShareProvider              from '../share';
import SidebarProvider            from '../sidebar';
import SiteSettingsProvider       from '../siteSettings';
import TabsProvider               from '../tabs';
import UserProvider               from '../user';
import VacanciesProvider          from '../vacancies';
import VerificationProvider       from '../verification';
import WhereBuyProvider           from '../whereBuy';

/**
 * @type {React.FC}
 */
const AppProvider = function({
  children,
  value,
}) {
  const {
          catalog,
          common,
          element,
          filter,
          information,
          location,
          nav,
          news,
          siteSettings,
          vacancies,
          verification,
          whereBuy,
          favoritesOfferData,
        } = value;

  return (
    <IntersectionProvider>
      <AlertProvider value={void 0}>
        <CatalogProvider
          value={{
            catalog,
            filter,
            element,
          }}
        >
          <CommonProvider value={common}>
            <InformationProvider value={information}>
              <LightboxProvider value={void 0}>
                <ModalProvider value={void 0}>
                  <NavigationProvider value={nav}>
                    <NewsProvider value={news}>
                      <SearchProvider value={void 0}>
                        <SidebarProvider value={void 0}>
                          <SiteSettingsProvider value={siteSettings}>
                            <TabsProvider value={void 0}>
                              <UserProvider value={location}>
                                <VacanciesProvider value={vacancies}>
                                  <VerificationProvider value={verification}>
                                    <WhereBuyProvider value={whereBuy}>
                                      <PromotionsProvider value={news}>
                                        <ShareProvider value={void 0}>
                                          <FavoritesProvider value={favoritesOfferData}>
                                            <BookmarksProvider>
                                              <NotificationProvider>
                                                <DealerRequestModalProvider>
                                                  <CompareModalProvider>
                                                    <DeleteCompareModalProvider>
                                                      <CompareProvider>
                                                        <CompletedProjectProvider value={{items: value.projects?.items}}>
                                                          <MapProvider value={{ apikey: process.env.YANDEX_MAP_API_KEY }}>
                                                            {children}
                                                          </MapProvider>
                                                        </CompletedProjectProvider>
                                                      </CompareProvider>
                                                    </DeleteCompareModalProvider>
                                                  </CompareModalProvider>
                                                </DealerRequestModalProvider>
                                              </NotificationProvider>
                                            </BookmarksProvider>
                                          </FavoritesProvider>
                                        </ShareProvider>
                                      </PromotionsProvider>
                                    </WhereBuyProvider>
                                  </VerificationProvider>
                                </VacanciesProvider>
                              </UserProvider>
                            </TabsProvider>
                          </SiteSettingsProvider>
                        </SidebarProvider>
                      </SearchProvider>
                    </NewsProvider>
                  </NavigationProvider>
                </ModalProvider>
              </LightboxProvider>
            </InformationProvider>
          </CommonProvider>
        </CatalogProvider>
      </AlertProvider>
    </IntersectionProvider>
  );
};

export default AppProvider;
